export interface FormParams {
  [key: string]: any;
}

const buildFormData = (params: FormParams = {}, removeEmpty = true): FormData => {
  const formData = new FormData();
  for (const key of Object.keys(params)) {
    if (!params[key] && removeEmpty && params[key] !== false) {
      continue;
    }
    let val = params[key];
    if (!(val instanceof Blob)) {
      val = "" + val;
    }
    formData.append(key, val);
  }
  return formData;
};

export default buildFormData;
